export const LANGUAGE_STORAGE_KEY = 'preferred_language';

export const SUPPORTED_LANGUAGES = ['zh', 'en'] as const;

export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: AppLanguage = 'zh';

export const isSupportedLanguage = (value: string | null): value is AppLanguage => {
  if (!value) return false;
  return SUPPORTED_LANGUAGES.includes(value as AppLanguage);
};

export const normalizeLanguage = (value: string | null | undefined): AppLanguage => {
  if (!value) return DEFAULT_LANGUAGE;
  const normalized = value.toLowerCase().split('-')[0];
  return isSupportedLanguage(normalized) ? normalized : DEFAULT_LANGUAGE;
};

export const getPreferredLanguage = (): AppLanguage => {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;

  const value = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return normalizeLanguage(value);
};

export const setPreferredLanguage = (language: AppLanguage): void => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
};
